import { sleep } from '@flowus/common/async';
import { useEffect, useRef } from 'react';

export const useTocScroll = (props: { toId: string; containerId: string; tocId: string }) => {
  const { containerId, toId, tocId } = props;
  const init = useRef(true);

  useEffect(() => {
    let isScroll = false;
    const run = () => {
      if (isScroll) return;
      init.current = false;

      const tocItem = document.querySelector(`#${tocId} #${containerId} [data-block-id='${toId}']`);

      const tocContainer = document.querySelector(`#${tocId} #${containerId}`);
      if (tocItem && tocContainer) {
        const tocItemRect = tocItem.getBoundingClientRect();
        const tocContainerRect = tocContainer.getBoundingClientRect();

        const isVisible =
          tocItemRect.top >= tocContainerRect.top && tocItemRect.bottom <= tocContainerRect.bottom;

        if (!isVisible) {
          const offset = tocItemRect.top - tocContainerRect.top;
          const scrollAmount = offset + tocContainer.scrollTop - 60; // 滚动到顶部并偏移 100px

          tocContainer.scrollTo({
            top: scrollAmount,
            behavior: 'smooth',
          });
        }
      }
    };

    if (init.current) {
      const firstScroll = () => {
        isScroll = true;
      };

      const tocContainer = document.querySelector(`#${tocId} #${containerId}`);
      tocContainer?.addEventListener('scroll', firstScroll);

      void sleep(1000).then(run);
      void sleep(1500).then(run);
      void sleep(1600).then(() => {
        isScroll = false;
      });
    } else {
      run();
    }

    return () => {
      // init.current = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toId]);
};
